// revolaxFillersData.ts

interface MetaData {
    title: string;
    description: string;
    robots?: string;
    canonical?: string;
    og?: {
        locale?: string;
        type?: string;
        title?: string;
        description?: string;
        url?: string;
        site_name?: string;
        updated_time?: string;
        image?: string;
        image_secure_url?: string;
        image_width?: number;
        image_height?: number;
        image_alt?: string;
        image_type?: string;
        video?: string;
        video_duration?: number;
        video_upload_date?: string;
        video_allow_embed?: boolean;
    };
    twitter?: {
        card?: string;
        title?: string;
        description?: string;
        image?: string;
    };
}

interface Step {
    title: string;
    desc: string;
    icon: string;
}

interface ProcedureSteps {
    heading: string;
    para: string;
    steps: Step[];
}

interface ListItem {
    title: string;
    desc: string;
    icon: string;
}

interface ListSection {
    heading?: string;
    subheading?: string;
    para?: string;
    items: ListItem[];
}

interface FAQItem {
    question: string;
    answer: string;
}

interface FAQSection {
    heading?: string;
    subheading?: string;
    items: FAQItem[];
}

interface HeroSection {
    title: string;
    subtitle: string;
    description: string;
}

interface HowItWorks {
    title: string;
    description: string;
}

interface TreatmentArea {
    ar: string;
    title: string;
    image: string;
}

interface internalLinking {
    heading: string;
    items: [] | any;
}

interface LanguageContent {
    url?: string; // Added url property
    meta: MetaData;
    breadcrumbs: string[];
    hero: HeroSection;
    howItWorks: HowItWorks;
    procedureSteps: ProcedureSteps;
    benefits: ListSection;
    eligibility: ListSection;
    preparationTips: ListSection;
    results: ListSection;
    aftercareTips: ListSection;
    internalLinking: internalLinking;
    faqData: FAQSection;
    treatmentAreas1: TreatmentArea[];
    treatmentAreas2: TreatmentArea[];
}

interface SharedData {
    images: {
        main: string;
        beforeAfter: string[];
        introductionImage?: string;
    };
    product: {
        id: number;
        title: string;
        price: number;
        description: string;
    };
}

export const revolaxFillers: {
    en: LanguageContent;
    ar: LanguageContent;
    shared: SharedData;
} =
{
    "en": {
        "url": "",
        "meta": {
            "title": "Revolax Fillers Dubai - Elite Body Home Polyclinic",
            "description": "Revolax filler is a high-quality, versatile dermal filler designed to combat the signs of aging and enhance facial contours. Known for its soft texture and high cross-linking technology, Revolax fillers are becoming increasingly popular for reducing fine lines, adding volume, and achieving a youthful appearance",
            "robots": "follow, index, max-snippet:-1, max-video-preview:-1, max-image-preview:large",
            "canonical": "https://elitebodyhome.com/services/revolax-fillers/",
            "og": {
                "locale": "en_US",
                "type": "article",
                "title": "Revolax Fillers Dubai - Elite Body Home Polyclinic",
                "description": "Revolax filler is a high-quality, versatile dermal filler designed to combat the signs of aging and enhance facial contours. Known for its soft texture and high cross-linking technology, Revolax fillers are becoming increasingly popular for reducing fine lines, adding volume, and achieving a youthful appearance",
                "url": "https://elitebodyhome.com/services/revolax-fillers/",
                "site_name": "elitebodyhome.com",
                "updated_time": "2025-01-22T13:57:12+00:00",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-65.jpg",
                "image_secure_url": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-65.jpg",
                "image_width": 1254,
                "image_height": 700,
                "image_alt": "Revolax Fillers",
                "image_type": "image/jpeg"
            },
            "twitter": {
                "card": "summary_large_image",
                "title": "Revolax Fillers Dubai - Elite Body Home Polyclinic",
                "description": "Revolax filler is a high-quality, versatile dermal filler designed to combat the signs of aging and enhance facial contours. Known for its soft texture and high cross-linking technology, Revolax fillers are becoming increasingly popular for reducing fine lines, adding volume, and achieving a youthful appearance",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-65.jpg"
            }
        },
        "breadcrumbs": ["Home", "Services", "Revolax Fillers Dubai"],
        "hero": {
            "title": "Revolax Fillers in Dubai",
            "subtitle": "Enhance Your Look, Empower Your Confidence",
            "description": "Premium quality dermal fillers for anti-aging and facial sculpting with natural-looking, long-lasting results."
        },
        "internalLinking": {
            "heading": "Explore Our Dermal Fillers for Complete Facial Enhancement",
            "items": [{ "name": "Chin Fillers", "link": "/services/chin-fillers-dubai" },
            { "name": "Nose Fillers", "link": "/services/nose-fillers-dubai" },
            { "name": "Juvederm Fillers", "link": "/services/juvederm-fillers" },
            { "name": "Jawline Fillers", "link": "/services/jawline-fillers-dubai" },
            { "name": "Teosyal Fillers", "link": "/services/teosyal-fillers" },
            { "name": "Under Eye Fillers", "link": "/services/under-eye-fillers-dubai" }
            ]
        },
        "howItWorks": {
            "title": "What Are Revolax Fillers?",
            "description": "Revolax filler is a premium quality, multi-functional dermal filler formulated for the treatment of anti-aging and facial sculpting. Known for their soft texture and highest cross-linking technology, they effectively treat fine lines, volume loss and restore youthful appearance."
        },
        "procedureSteps": {
            "heading": "The Procedure For Revolax Filler: Step By Step",
            "para": "A minimally invasive treatment providing immediate, natural-looking results for facial contouring, wrinkles and lip plumping.",
            "steps": [
                {
                    "title": "Consultation",
                    "desc": "Evaluation of your aesthetic goals and medical history.",
                    "icon": "fa-regular fa-comment-dots"
                },
                {
                    "title": "Preparation",
                    "desc": "Cleaning the treatment area and applying numbing cream.",
                    "icon": "fa-regular fa-hand-sparkles"
                },
                {
                    "title": "Injections",
                    "desc": "Precise injections into targeted areas using fine needles or cannulas.",
                    "icon": "fa-solid fa-syringe"
                },
                {
                    "title": "Immediate Results",
                    "desc": "Visible improvement in facial contours and volume immediately.",
                    "icon": "fa-regular fa-face-smile"
                },
                {
                    "title": "Shaping",
                    "desc": "Light massage for even distribution and smooth results.",
                    "icon": "fa-regular fa-hand"
                },
                {
                    "title": "Post-Procedure Care",
                    "desc": "Aftercare instructions including avoiding heavy activities and sun exposure.",
                    "icon": "fa-regular fa-clipboard"
                }
            ]
        },
        "benefits": {
            "heading": "Revolax Fillers: The Key Features",
            "subheading": "",
            "para": "Versatile and safe treatment with advantages from reducing wrinkles to facial sculpting.",
            "items": [
                {
                    "title": "High Purity Hyaluronic Acid",
                    "desc": "Non-animal, biodegradable, highly compatible with skin.",
                    "icon": "fa-solid fa-leaf"
                },
                {
                    "title": "Natural-Looking Results",
                    "desc": "Gel-like consistency allows for natural movement and expression.",
                    "icon": "fa-regular fa-face-grin"
                },
                {
                    "title": "Long-Lasting Effects",
                    "desc": "Results last 12 to 18 months depending on area and metabolism.",
                    "icon": "fa-solid fa-hourglass"
                },
                {
                    "title": "Customizable Treatments",
                    "desc": "Available in formulations for fine lines to deep wrinkles and volume loss.",
                    "icon": "fa-solid fa-sliders"
                },
                {
                    "title": "Minimal Downtime",
                    "desc": "30-minute procedure with immediate return to regular activities.",
                    "icon": "fa-solid fa-clock"
                },
                {
                    "title": "Cost-Effective",
                    "desc": "High-quality, long-lasting value compared to competitors.",
                    "icon": "fa-solid fa-tag"
                }
            ]
        },
        "eligibility": {
            "heading": "Who Can Use Revolax Fillers?",
            "subheading": "",
            "para": "Designed for individuals wishing to enhance facial structure or combat aging with specific eligibility requirements.",
            "items": [
                {
                    "title": "Age 18+",
                    "desc": "For facial beautification without surgical methods.",
                    "icon": "fa-solid fa-user"
                },
                {
                    "title": "Wrinkle Concerns",
                    "desc": "Those with mild to moderate wrinkles or volume loss.",
                    "icon": "fa-regular fa-face-meh"
                },
                {
                    "title": "Facial Enhancement",
                    "desc": "Seeking lip volume, cheek definition or reduced nasolabial folds.",
                    "icon": "fa-solid fa-lips"
                },
                {
                    "title": "Health Status",
                    "desc": "No history of severe allergic reactions or chronic skin conditions.",
                    "icon": "fa-solid fa-heart-pulse"
                }
            ]
        },
        "preparationTips": {
            "heading": "Preparation for Your Revolax Treatment",
            "subheading": "",
            "para": "Proper preparation leads to best results and limits possible side effects.",
            "items": [
                {
                    "title": "Avoid Blood Thinners",
                    "desc": "Stop aspirin/ibuprofen for at least a week before to limit bruising.",
                    "icon": "fa-solid fa-pills"
                },
                {
                    "title": "Limit Alcohol/Smoking",
                    "desc": "Refrain 24-48 hours prior to boost recovery.",
                    "icon": "fa-solid fa-wine-glass-empty"
                },
                {
                    "title": "Hydrate Well",
                    "desc": "Drink plenty of water for skin hydration and filler effectiveness.",
                    "icon": "fa-solid fa-droplet"
                },
                {
                    "title": "Medical Disclosure",
                    "desc": "Inform practitioner about allergies, medications and medical history.",
                    "icon": "fa-regular fa-clipboard-question"
                }
            ]
        },
        "results": {
            "heading": "What Results to Expect",
            "subheading": "",
            "para": "Visible improvements immediately after treatment that continue to enhance as filler integrates with skin.",
            "items": [
                {
                    "title": "Immediate Volume",
                    "desc": "Noticeable increased volume in treated areas like cheeks, lips or under eyes.",
                    "icon": "fa-solid fa-plus"
                },
                {
                    "title": "Refined Features",
                    "desc": "Highlighted facial contours and softened fine lines for fresher appearance.",
                    "icon": "fa-solid fa-magnifying-glass"
                },
                {
                    "title": "Natural-Looking Outcomes",
                    "desc": "Subtle enhancements that maintain natural facial expressions.",
                    "icon": "fa-regular fa-face-grin-stars"
                },
                {
                    "title": "Long-Term Satisfaction",
                    "desc": "Proper aftercare maintains results for optimal duration.",
                    "icon": "fa-solid fa-calendar-check"
                }
            ]
        },
        "aftercareTips": {
            "heading": "",
            "subheading": "",
            "para": "",
            "items": []
        },
        "faqData": {
            "heading": "Frequently Asked Questions",
            "subheading": "",
            "items": [
                {
                    "question": "How soon will I see results?",
                    "answer": "Results are visible immediately after the procedure, with improvements continuing as the filler settles over the following days."
                },
                {
                    "question": "Is the treatment painful?",
                    "answer": "Most Revolax fillers contain lidocaine to minimize discomfort. Mild swelling or tenderness typically subsides within few days."
                },
                {
                    "question": "How long do the effects last?",
                    "answer": "Results last 12 to 18 months depending on the filler type and treated area."
                },
                {
                    "question": "Are there any side effects?",
                    "answer": "Common temporary effects include mild bruising, redness and swelling. Serious complications are rare with proper administration."
                }
            ]
        },
        "treatmentAreas1": [
        ],
        "treatmentAreas2": [
        ]
    },
    "shared": {
        "images": {
            "introductionImage": "",
            "main": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/New-Service-Banner-Image-9-scaled.jpg",
            "beforeAfter": [
                "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Dermal-Filler-1.webp",
                "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/52.webp",
                "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Dermal-Filler-2.webp"
            ]
        },
        "product": {
            "id": 113,
            "title": "Revolax Dermal Fillers",
            "price": 699,
            "description": "Revolax is a soft-tissue dermal filler formulated with cross-linked hyaluronic acid to smooth wrinkles, contour features, and restore youthful volume. Ideal for lips, cheeks, and nasolabial folds."
        },
    },

    "ar": {
        "url": "",
        "meta": {
            "title": "فيلر ريفولاكس في دبي - عيادة إيليت بودي هوم",
            "description": "فيلر ريفولاكس هو فيلر جلدي عالي الجودة متعدد الاستخدامات، مُصمم لمكافحة علامات التقدم في العمر وتحديد ملامح الوجه. يُعرف بملمسه الناعم وتقنية الربط المتطورة، مما يجعله خيارًا مثاليًا لتقليل الخطوط الدقيقة وإضافة الحجم وتحقيق مظهر شبابي.",
            "robots": "follow, index, max-snippet:-1, max-video-preview:-1, max-image-preview:large",
            "canonical": "https://elitebodyhome.com/ar/revolax-fillers/",
            "og": {
                "locale": "ar_AR",
                "type": "article",
                "title": "فيلر ريفولاكس في دبي - عيادة إيليت بودي هوم",
                "description": "فيلر ريفولاكس هو فيلر جلدي عالي الجودة متعدد الاستخدامات، مُصمم لمكافحة علامات التقدم في العمر وتحديد ملامح الوجه.",
                "url": "https://elitebodyhome.com/ar/revolax-fillers/",
                "site_name": "elitebodyhome.com",
                "updated_time": "2025-01-22T13:57:12+00:00",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-65.jpg",
                "image_secure_url": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-65.jpg",
                "image_width": 1254,
                "image_height": 700,
                "image_alt": "فيلر ريفولاكس",
                "image_type": "image/jpeg"
            },
            "twitter": {
                "card": "summary_large_image",
                "title": "فيلر ريفولاكس في دبي - عيادة إيليت بودي هوم",
                "description": "فيلر ريفولاكس هو فيلر جلدي عالي الجودة متعدد الاستخدامات، مُصمم لمكافحة علامات التقدم في العمر وتحديد ملامح الوجه.",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-65.jpg"
            }
        },
        "breadcrumbs": ["الرئيسية", "الخدمات", "فيلر ريفولاكس في دبي"],
        "hero": {
            "title": "فيلر ريفولاكس في دبي",
            "subtitle": "عززي مظهرك، عززي ثقتك بنفسك",
            "description": "فيلر جلدي عالي الجودة لمكافحة الشيخوخة ونحت الوجه مع نتائج طبيعية طويلة الأمد."
        },
        "internalLinking": {
            "heading": "اكتشف مجموعاتنا من فيلر البشرة لتعزيز جمال الوجه بالكامل",
            "items": [
                { "name": "مجموعة فيلر الوجه", "link": "/services/face-fillers" },
                { "name": "مجموعة فيلر الذقن", "link": "/services/chin-fillers" },
                { "name": "مجموعة فيلر الأنف", "link": "/services/nose-fillers" },
                { "name": "مجموعة فيلر الشفاه", "link": "/services/lip-fillers" },
                { "name": "مجموعة فيلر خط الذقن", "link": "/services/jawline-fillers" },
                { "name": "مجموعة فيلر تحت العين", "link": "/services/under-eye-fillers" }
            ]
        },
        "howItWorks": {
            "title": "ما هو فيلر ريفولاكس؟",
            "description": "فيلر ريفولاكس هو فيلر جلدي عالي الجودة متعدد الاستخدامات، مُصمم لمكافحة علامات التقدم في العمر وتحديد ملامح الوجه. يُعرف فيلر ريفولاكس بملمسه الناعم وتتميز عملية تصنيعه باستخدام أحدث تقنيات الربط، فأصبح شائع استخدامه في ملء الخطوط الدقيقة واستعادة حجم الوجه والمظهر الشبابي."
        },
        "procedureSteps": {
            "heading": "خطوات إجراء فيلر ريفولاكس",
            "para": "إجراء غير جراحي يوفر نتائج طبيعية وفورية، مثالي لتحديد ملامح الوجه، أو ملء التجاعيد أو تكبير الشفاه.",
            "steps": [
                {
                    "title": "الاستشارة",
                    "desc": "تبدأ رحلة العلاج باستشارة شاملة لتقييم أهدافك الجمالية ومعرفة تاريخك الطبي.",
                    "icon": "fa-regular fa-comment-dots"
                },
                {
                    "title": "الاستعداد",
                    "desc": "تُنظف المنطقة المراد علاجها، ويُستخدم كريم مخدر لتقليل الشعور بالألم.",
                    "icon": "fa-regular fa-hand-sparkles"
                },
                {
                    "title": "الحقن",
                    "desc": "يُحقن الفيلر بدقة في المناطق المستهدفة في الوجه باستخدام إبر أو قنيات دقيقة.",
                    "icon": "fa-solid fa-syringe"
                },
                {
                    "title": "النتائج الفورية",
                    "desc": "ستلاحظ تحسنًا فوريًا في ملامح الوجه وحجمه بعد الإجراء مباشرة.",
                    "icon": "fa-regular fa-face-smile"
                },
                {
                    "title": "تشكيل الفيلر",
                    "desc": "يقوم المتخصص بتدليك خفيف للمناطق التي تم علاجها، لضمان توزيع متساوٍ ونتائج ناعمة.",
                    "icon": "fa-regular fa-hand"
                },
                {
                    "title": "العناية بعد الحقن",
                    "desc": "تتضمن تعليمات العناية ما بعد الإجراء إرشادات حول كيفية العناية بالمنطقة في الأيام التالية للعلاج.",
                    "icon": "fa-regular fa-clipboard"
                }
            ]
        },
        "benefits": {
            "heading": "فيلر ريفولاكس: الميزات الرئيسية",
            "subheading": "",
            "para": "تتعدد استخدامات فيلر ريفولاكس، ويتميز بالعديد من الفوائد التي تتراوح بين تقليل التجاعيد إلى نحت الوجه.",
            "items": [
                {
                    "title": "احتواءه على حمض الهيالورونيك عالي النقاء",
                    "desc": "يتكون من حمض الهيالورونيك غير الحيواني والقابل للتحلل الحيوي، مما يجعله متوافقًا مع البشرة.",
                    "icon": "fa-solid fa-leaf"
                },
                {
                    "title": "نتائج طبيعية",
                    "desc": "يسمح قوامه الهلامي بالحركة والتعابير الطبيعية للوجه بعد العلاج.",
                    "icon": "fa-regular fa-face-grin"
                },
                {
                    "title": "نتائج تدوم طويلًا",
                    "desc": "يمكن أن تدوم النتائج من 12 إلى 18 شهرًا، حسب المنطقة المعالجة.",
                    "icon": "fa-solid fa-hourglass"
                },
                {
                    "title": "خطط علاجية مخصصة",
                    "desc": "يتوفر بعدة تركيبات لمعالجة المشكلات المختلفة من الخطوط الدقيقة إلى التجاعيد العميقة.",
                    "icon": "fa-solid fa-sliders"
                },
                {
                    "title": "لا يتطلب فترة تعافي طويلة",
                    "desc": "يستغرق الإجراء حوالي 30 دقيقة، مع عودة سريعة للروتين اليومي.",
                    "icon": "fa-solid fa-clock"
                },
                {
                    "title": "تكلفة مناسبة",
                    "desc": "فيلر عالي الجودة وطويل الأمد يقدم قيمة جيدة مقابل المال.",
                    "icon": "fa-solid fa-tag"
                }
            ]
        },
        "eligibility": {
            "heading": "من هو المرشح المناسب لفيلر ريفولاكس؟",
            "subheading": "",
            "para": "صُمم فيلر ريفولاكس للأشخاص الذين يرغبون في تحسين بنية الوجه أو مكافحة علامات التقدم في العمر.",
            "items": [
                {
                    "title": "الأشخاص 18 عامًا فأكثر",
                    "desc": "الراغبون في تحسين ملامح وجههم دون اللجوء إلى الإجراءات الجراحية.",
                    "icon": "fa-solid fa-user"
                },
                {
                    "title": "من يعانون من تجاعيد",
                    "desc": "الأشخاص الذين يعانون من تجاعيد خفيفة إلى متوسطة أو فقدان في حجم الوجه.",
                    "icon": "fa-regular fa-face-meh"
                },
                {
                    "title": "تحسين ملامح الوجه",
                    "desc": "الراغبون في إضافة حجم للشفاه، أو تحديد الخدين، أو تقليل خطوط الابتسامة.",
                    "icon": "fa-solid fa-lips"
                },
                {
                    "title": "الحالة الصحية",
                    "desc": "الأشخاص الذين ليس لديهم تاريخ صحي من ردود فعل تحسسية شديدة أو أمراض جلدية مزمنة.",
                    "icon": "fa-solid fa-heart-pulse"
                }
            ]
        },
        "preparationTips": {
            "heading": "الاستعداد",
            "subheading": "",
            "para": "يساعد التحضير الجيد في الحصول على أفضل النتائج من علاج فيلر ريفولاكس.",
            "items": [
                {
                    "title": "تجنب مُميعات الدم",
                    "desc": "امتنع عن تناول الأسبرين أو الإيبوبروفين أو أي أدوية مميعة للدم لمدة لا تقل عن أسبوع قبل الجلسة.",
                    "icon": "fa-solid fa-pills"
                },
                {
                    "title": "الامتناع عن الكحول والتدخين",
                    "desc": "امتنع عن الكحول والتدخين لمدة 24-48 ساعة قبل العلاج لتعزيز عملية التعافي.",
                    "icon": "fa-solid fa-wine-glass-empty"
                },
                {
                    "title": "الترطيب الجيد للجسم",
                    "desc": "يجب شرب كميات كافية من الماء، للحفاظ على ترطيب بشرتك وضمان فعالية حمض الهيالورونيك.",
                    "icon": "fa-solid fa-droplet"
                },
                {
                    "title": "إبلاغ الطبيب بالتاريخ الطبي",
                    "desc": "أخبر الطبيب بتاريخك الطبي والعلاجي وكل الحساسية التي تعاني منها، وكل الأدوية التي تتناولها حاليًا.",
                    "icon": "fa-regular fa-clipboard-question"
                }
            ]
        },
        "results": {
            "heading": "النتائج",
            "subheading": "",
            "para": "تظهر نتائج فيلر ريفولاكس على الفور، حيث يوفر مظهرًا أكثر نعومة وشبابًا يتحسن مع مرور الوقت.",
            "items": [
                {
                    "title": "امتلاء فوري في الحجم",
                    "desc": "سيلاحظ المرضى زيادة في الحجم بعد الحقن مباشرةً في المناطق التي تم علاجها.",
                    "icon": "fa-solid fa-plus"
                },
                {
                    "title": "نتائج دقيقة",
                    "desc": "يساعد في إعادة توازن ملامح الوجه، وتنعيم الخطوط الدقيقة والتجاعيد.",
                    "icon": "fa-solid fa-magnifying-glass"
                },
                {
                    "title": "نتائج طبيعية",
                    "desc": "تُعد إحدى الخصائص الرئيسية لجميع أنواع فيلر ريفولاكس تقديم نتائج طبيعية ودقيقة.",
                    "icon": "fa-regular fa-face-grin-stars"
                },
                {
                    "title": "شعور بالرضا يدوم طويلًا",
                    "desc": "تتمثل إحدى أبرز مزايا فيلر ريفولاكس في أنه يحقق رضا طويل الأمد للمرضى.",
                    "icon": "fa-solid fa-calendar-check"
                }
            ]
        },
        "aftercareTips": {
            "heading": "",
            "subheading": "",
            "para": "",
            "items": []
        },
        "faqData": {
            "heading": "الأسئلة المكررة",
            "subheading": "",
            "items": [
                {
                    "question": "متى سأرى النتائج؟",
                    "answer": "تظهر النتائج مباشرة بعد الإجراء، مع استمرار التحسن خلال الأيام التالية."
                },
                {
                    "question": "هل العلاج مؤلم؟",
                    "answer": "معظم أنواع فيلر ريفولاكس تحتوي على مخدر موضعي لتقليل الألم. قد يكون هناك تورم خفيف يزول خلال أيام قليلة."
                },
                {
                    "question": "كم تدوم النتائج؟",
                    "answer": "تدوم النتائج من 12 إلى 18 شهرًا حسب نوع الفيلر والمنطقة المعالجة."
                },
                {
                    "question": "هل هناك أي آثار جانبية؟",
                    "answer": "الآثار الجانبية الشائعة مؤقتة وتشمل كدمات خفيفة واحمرار وتورم. المضاعفات الخطيرة نادرة عند التنفيذ الصحيح."
                }
            ]
        },
        "treatmentAreas1": [],
        "treatmentAreas2": []

    }
};
